import React from 'react'

const Icons = () => (
  <ul className="icons">
    <li>
      <a href="https://github.com/gunins" className="icon alt fa-github"><span className="label">GitHub</span></a>
    </li>
    <li>
      <a href="https://www.linkedin.com/in/guntarssimanskis/" className="icon alt fa-linkedin"><span
        className="label">LinkedIn</span></a>
    </li>
    <li>
      <a href="https://twitter.com/simanskis" className="icon alt fa-twitter"><span
        className="label">Twitter</span></a>
    </li>
  </ul>
)
export default Icons
